module.exports = __webpack_public_path__ + "static/media/meps motores hasta 100hp.0138437f.jpg";